import { dataService } from "../services/data.services";
import { userService } from "../services/user.services";
import { clearAuthSession, setAuthItem } from './authSession';

export const CheckUserStatus = async()=>{

    let user=true;

    try {
        const user1 = await dataService.GetAPI('providers/check-status');
        setAuthItem('custom-status', user1?.data?.data?.user_status);
        if (user1?.data?.data?.user_status==='inactive') {
            user=false;
            await userService.logout()
            clearAuthSession();
            setAuthItem('custom-status', 'inactive');
            setTimeout(() => {
                window.location.reload();
            }, 500);
        } 
    }catch (e) {
        if (e.response?.status === 401 || e.response?.status === 403) {
            user = false;
            clearAuthSession();
            setTimeout(() => {
                window.location.reload();
            }, 500);
        } else {
            user = false;
        }
    }
    return user

}
   

        

    





